import React, { useEffect, useRef, useState } from 'react';

const TAGLINES = [
  "const { cloud, fullStack, leadership } = require('senior_engineer')",
  "Architecting scalable SaaS platforms on AWS",
  "From EV charging infrastructure to enterprise solutions",
];

const TypingTagline: React.FC = () => {
  const [taglineIndex, setTaglineIndex] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const tagline = TAGLINES[taglineIndex];
    let charIndex = 0;
    setDisplayText('');
    setIsTyping(true);

    intervalRef.current = setInterval(() => {
      if (charIndex < tagline.length) {
        setDisplayText(tagline.slice(0, charIndex + 1));
        charIndex++;
      } else {
        setIsTyping(false);
        if (intervalRef.current) clearInterval(intervalRef.current);
        timeoutRef.current = setTimeout(() => {
          setTaglineIndex((prev) => (prev + 1) % TAGLINES.length);
        }, 3000);
      }
    }, 50);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [taglineIndex]);

  return (
    <div className="h-8 mb-10">
      <p className="font-mono text-sm md:text-base text-gray-400">
        <span className="text-neon-cyan">{'> '}</span>
        {displayText}
        <span className={`${isTyping ? 'animate-pulse' : 'opacity-0'} text-accent`}>|</span>
      </p>
    </div>
  );
};

export default TypingTagline;
